import Vue from "vue";
import App from "./App.vue";
import i18n from "./i18n";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";

// VueTheMask
import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

// LOAD FONT AWESOME
import "@fortawesome/fontawesome-free/css/all.css";

// VueTimepicker
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
Vue.component("time-picker", VueTimepicker); // used in BaseWeekAvailabilityTable.vue only

// DAYJS
import dayjs from "dayjs";
import "dayjs/locale/it";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.locale("it");
dayjs.extend(utc);
dayjs.extend(timezone);
console.log("timezone from dayjs.tz.guess()", dayjs.tz.guess());
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

// LODASH
import camelCase from "lodash/camelCase";
import upperFirst from "lodash/upperFirst";

// DIALOGS
import ConfirmDialog from "./components/Dialogs/BaseConfirmDialog.vue";
import ErrorDialog from "./components/Dialogs/BaseErrorDialog.vue";
import LoadingDialog from "./components/Dialogs/BaseLoadingDialog.vue";
import SuccessDialog from "./components/Dialogs/BaseSuccessDialog.vue";
Vue.component("loading-dialog", LoadingDialog);
Vue.component("error-dialog", ErrorDialog);
Vue.component("success-dialog", SuccessDialog);
Vue.component("confirm-dialog", ConfirmDialog);

// COMMON USED COMPONENTS
import AutocompleteSearch from "./components/AutocompleteSearch.vue";
import TheMainMenu from "./components/Main_menu/TheMainMenu";
Vue.component("main-menu", TheMainMenu);
Vue.component("autocomplete-search", AutocompleteSearch);

// AUTOMATICALLY IMPORT AND REGISTER GLOBAL COMPONENTS (NAME PATTERN Base*.vue)
const requireComponent = require.context(
  // The relative path of the components folder
  "./components",
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /Base[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName);
  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  );
  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  );
});

Vue.config.productionTip = false;
Vue.config.devtools = true;

i18n.locale = "it";

// F I L T E R S / P I P E S
/**
 * it takes as an argument a Date and tranforms it  transforms it to given moment.js format
 *
 * Usage:
 *  date = 'Thu Jul 11 2019 09:29:47 GMT+0300 (Eastern European Summer Time)'
 *  format = 'DD-MM-YYYY HH:mm'
 *  {{ date | date(format) }}
 *
 * Output: '11-07-2019 09:29'
 */
Vue.filter("date", (date, format) => {
  let dayjsDate = dayjs(String(date));
  return dayjsDate.isValid()
    ? dayjsDate.format(format)
    : i18n.t("notAvailable");
});

Vue.filter("titlecase", str => {
  if (str) {
    return str[0].toUpperCase() + str.slice(1);
  }
});

Vue.filter("decimals", (value, decimals) => {
  value = value || 0.0;
  let formatter = new Intl.NumberFormat("it-IT", {
    maximumFractionDigits: decimals || 0,
    minimumFractionDigits: decimals || 0
  });
  return formatter.format(Number.parseFloat(value));
});

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
